package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.project.responseModels.BagCategoryLists
import com.example.mystybag.sharedmodels.project.responseModels.merchant.MerchantLocationResponseModel
import com.example.mystybag.sharedmodels.project.responseModels.merchant.ReservationItem
import kotlinx.datetime.LocalDate

enum class DashboardPeriod {

    TODAY,
    LAST_WEEK,
    LAST_MONTH,
    PERIOD
}

data class SalesDataPoint(
    val date: String,
    val amount: Double,
    val count: Int
)

data class LocationSalesBreakdown(
    val locationId: Long,
    val locationName: String,
    val sales: Double,
    val revenue: Double
)

/** categoryKey = ключ за string resource, напр. review_rating_taste, review_rating_quality, review_rating_freshness, review_rating_value */
data class CategoryRatingItem(
    val categoryKey: String,
    val rating: Double
)

data class DashboardUIState(
    val isLoading: Boolean = false,
    /** True when this user is signed in as merchant staff (employee). Owner/admin users see [canViewRevenue] = true. */
    val isStaff: Boolean = false,
    /** When false (staff without revenue permission), revenue is rendered as "**.**" instead of the actual value. */
    val canViewRevenue: Boolean = true,
    val bags: BagCategoryLists? = null,
    val locations: List<MerchantLocationResponseModel> = emptyList(),
    val companyPhoneNumber: String? = null,
    val companyDialCode: String? = null,
    val registeredCompanyStreet: String? = null,
    val registeredCompanyCityId: Long? = null,
    val registeredCompanyCityName: String? = null,
    val selectedPeriod: DashboardPeriod = DashboardPeriod.TODAY,
    /** При [DashboardPeriod.PERIOD]: граници на периода (включително). */
    val customPeriodFrom: LocalDate? = null,
    val customPeriodTo: LocalDate? = null,
    val selectedLocationId: Long? = null, // null = всички обекти, иначе конкретен обект
    val soldBagsCount: Int = 0,
    /** Сума от количествата торби по резервация (bagsCount) за същия набор като KPI „Продажби“. */
    val soldBagUnitsTotal: Int = 0,
    val totalRevenue: Double = 0.0,
    val toDeliverCount: Int = 0,
    val unpaidAmount: Double = 0.0,
    val paidAmount: Double = 0.0,
    val reservations: List<ReservationItem> = emptyList(),
    // Reviews section (Overview)
    val averageRating: Double = 0.0,
    val reviewCount: Int = 0,
    val categoryRatings: List<CategoryRatingItem> = emptyList()
)

